// Types
import {contractDateTime} from '@drivesally/sally-fn/lib/types';

export default () => contractDateTime(new Date()).format();
